var allowedTags = {
  a: ['href', 'title'],
  blockquote: [],
  br: [],
  code: [],
  del: [],
  em: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  hr: [],
  img: ['alt', 'src', 'title'],
  li: [],
  ol: [],
  p: [],
  pre: [],
  q: [],
  strong: [],
  sub: [],
  sup: [],
  table: [],
  tbody: [],
  td: ['align'],
  th: ['align'],
  thead: [],
  tr: [],
  ul: []
};

var removeWithContents = {
  base: true,
  embed: true,
  form: true,
  iframe: true,
  input: true,
  link: true,
  math: true,
  meta: true,
  object: true,
  script: true,
  style: true,
  svg: true,
  template: true
};

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function safeUrl(value, allowMailto) {
  var url = String(value || '').trim().replace(/[\u0000-\u0020]/g, '');
  if (!url) return false;
  if (/^https?:/i.test(url)) return true;
  if (allowMailto && /^mailto:/i.test(url)) return true;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return false;
  return !/^[/\\]{2}/.test(url);
}

function unwrap(element) {
  if (!element.parentNode) return;
  while (element.firstChild) {
    element.parentNode.insertBefore(element.firstChild, element);
  }
  element.parentNode.removeChild(element);
}

function sanitizeMarkdownHtml(html) {
  if (typeof document === 'undefined' || !document.createElement) {
    return escapeHtml(html);
  }

  var container = document.createElement('div');
  container.innerHTML = String(html || '');
  Array.prototype.slice.call(container.querySelectorAll('*')).forEach(function (element) {
    var tagName = element.tagName.toLowerCase();
    if (removeWithContents[tagName]) {
      element.remove();
      return;
    }
    if (!allowedTags[tagName]) {
      unwrap(element);
      return;
    }

    Array.prototype.slice.call(element.attributes).forEach(function (attribute) {
      var name = attribute.name.toLowerCase();
      var allowedAttributes = allowedTags[tagName];
      if (allowedAttributes.indexOf(name) === -1) {
        element.removeAttribute(attribute.name);
        return;
      }
      if (name === 'href' && !safeUrl(attribute.value, true)) {
        element.removeAttribute(attribute.name);
      }
      if (name === 'src' && !safeUrl(attribute.value, false)) {
        element.removeAttribute(attribute.name);
      }
      if (name === 'align' && !/^(left|center|right)$/i.test(attribute.value)) {
        element.removeAttribute(attribute.name);
      }
    });
  });
  return container.innerHTML;
}

module.exports = sanitizeMarkdownHtml;
